/**
 * urql client for GraphQL. Always POST to same origin + /services/realestategateway/graphql.
 * Production: https://bostello.com/services/realestategateway/graphql
 * Local dev: vite proxy forwards /services/realestategateway -> backend (e.g. localhost:4003).
 */
import { createClient, type Client, cacheExchange, fetchExchange } from '@urql/core'

const GATEWAY_PATH = '/services/realestategateway/graphql'

function getDefaultUrl(): string {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}${GATEWAY_PATH}`
  }
  return GATEWAY_PATH
}

let sharedClient: Client | null = null
let sharedClientUrl: string | null = null

export function getGraphqlUrl(override?: string): string {
  if (override && override.trim()) return override.trim()
  return getDefaultUrl()
}

export function createUrqlClient(url: string): Client {
  return createClient({
    url,
    requestPolicy: 'network-only',
    fetchOptions: () => ({
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'broker-id': 'bost-contact-form',
      },
    }),
    exchanges: [cacheExchange, fetchExchange],
  })
}

export function getOrCreateUrqlClient(urlOverride?: string): Client {
  const url = getGraphqlUrl(urlOverride)
  if (sharedClient && sharedClientUrl === url) return sharedClient
  sharedClientUrl = url
  sharedClient = createUrqlClient(url)
  return sharedClient
}

export function resetUrqlClient(): void {
  sharedClient = null
  sharedClientUrl = null
}
